import { Type } from '@angular/core';
import { SingleWidget } from './widget.model';

export class WidgetItem {
    constructor(public component: Type<any>, public data: SingleWidget) { }
}
export interface Widgetomponent {
    data: SingleWidget;
}